export default __webpack_public_path__ + "static/media/JAQUEZ.8981d017.png";